import IconPhysics from '@ucheba/ui/icons/icon__atom.svg'
import IconMathematics from '@ucheba/ui/icons/icon__math.svg'
import IconRussian from '@ucheba/ui/icons/icon__russian.svg'
import IconInformatics from '@ucheba/ui/icons/icon__mouse.svg'
import IconSocial from '@ucheba/ui/icons/icon__socium.svg'
import IconGeography from '@ucheba/ui/icons/icon__geo.svg'
import IconEnglish from '@ucheba/ui/icons/icon__english.svg'
import IconChemistry from '@ucheba/ui/icons/icon__chimstery.svg'
import IconLiterature from '@ucheba/ui/icons/icon__pero.svg'
import IconHistory from '@ucheba/ui/icons/icon__history.svg'
import IconBiology from '@ucheba/ui/icons/icon__dnk.svg'
import IconForeignlanguage from '@ucheba/ui/icons/icon__lang-message.svg'

/** получаем иконку предмета по slug */
export const getSubjectIcon = (subjectSlug: string): Element | null => {
  const icons = {
    mathematics: IconMathematics,
    russian: IconRussian,
    informatics: IconInformatics,
    foreignlanguage: IconForeignlanguage,
    social: IconSocial,
    physics: IconPhysics,
    geography: IconGeography,
    english: IconEnglish,
    chemistry: IconChemistry,
    literature: IconLiterature,
    history: IconHistory,
    biology: IconBiology,
  }

  if (icons[subjectSlug]) {
    return icons[subjectSlug]
  }

  return null
}
